define(["mobx-state-tree","jquery","gemini/lib/@waca/dashboard-common/dist/core/APIFactory","underscore","gemini/lib/@waca/dashboard-common/dist/ui/AuthoringToolbar","gemini/lib/@waca/dashboard-common/dist/utils/ActionTypes","gemini/lib/@waca/dashboard-common/dist/utils/MemUtil"], function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_32__, __WEBPACK_EXTERNAL_MODULE_33__, __WEBPACK_EXTERNAL_MODULE_34__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 26);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2019, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * Gets the number of filter items
 * @param {object} localFilter the filter applied.
 * @return the number of filter items applied. If filter number is not applicable, return null
 */
var getNumberOfFilterItems = exports.getNumberOfFilterItems = function getNumberOfFilterItems(localFilter) {
	if (localFilter) {
		if (localFilter.operator === 'in' || localFilter.operator === 'notin' || localFilter.operator === 'isnull') {
			return localFilter.values.length;
		}
	}
	return null;
};

// Scrollable drag constants
var SCROLL_DRAG_DISTANCE = 20;
var handleScroll = exports.handleScroll = function handleScroll(e, scrollableContainer, onScrollCallback) {
	var boundingRect = scrollableContainer.getBoundingClientRect();
	var rect = {
		top: boundingRect.top,
		bottom: boundingRect.bottom
	};
	if (e.type === 'touchmove') {
		var coords = e.touches[0];
		if (coords) {
			e.clientX = coords.clientX;
			e.clientY = coords.clientY;
		}
	}
	if (!e.clientX || !e.clientY) {
		return;
	}
	var position = {
		x: e.clientX,
		y: e.clientY
	};
	var distanceBottom = rect.bottom - position.y;
	var distanceTop = position.y - rect.top;
	var isScrollingBottom = distanceBottom > 0 && distanceBottom < SCROLL_DRAG_DISTANCE;
	var isScrollingTop = distanceTop > 0 && distanceTop < SCROLL_DRAG_DISTANCE;
	var distanceY = 0;
	if (isScrollingTop && isScrollingBottom) {
		isScrollingTop = distanceTop > distanceBottom;
		isScrollingBottom = !isScrollingTop;
	}
	if (isScrollingBottom) {
		distanceY = SCROLL_DRAG_DISTANCE - distanceBottom;
	} else if (isScrollingTop) {
		distanceY = distanceTop - SCROLL_DRAG_DISTANCE;
	}
	var newScrollTop = scrollableContainer.scrollTop + distanceY;
	if (newScrollTop <= 0) {
		newScrollTop = 0;
	} else {
		var maxScrollTop = scrollableContainer.scrollHeight - scrollableContainer.clientHeight;
		if (newScrollTop > maxScrollTop) {
			newScrollTop = maxScrollTop;
		}
	}
	if (scrollableContainer.scrollTop !== newScrollTop) {
		scrollableContainer.scrollTop = newScrollTop;
		if (onScrollCallback) {
			onScrollCallback();
		}
	}
};

/** this function returns datasource id that will be used in type in dropdown
 * it exercises following logic: 
 * 1. if there is active datasource id, use it
 * 2. else, use first datasource id in the list of datasources
 */
var getDataSourceIdTypeIn = exports.getDataSourceIdTypeIn = function getDataSourceIdTypeIn(dashboardApi) {
	var sourceId = dashboardApi.getActiveDataSourceId();
	if (!sourceId) {
		var dataSourceFeature = dashboardApi.getFeature('DataSources');
		if (dataSourceFeature.getDataSourceList().length > 0) {
			sourceId = dataSourceFeature.getDataSourceList()[0].getId();
		}
	}
	return sourceId;
};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_8__;

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * IBM Business Analytics (C) Copyright IBM Corp. 2020, 2021
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _DropZonesOverlayStateAPI = __webpack_require__(27);

var _DropZonesOverlayStateAPI2 = _interopRequireDefault(_DropZonesOverlayStateAPI);

var _OverlayModel = __webpack_require__(28);

var _OverlayModel2 = _interopRequireDefault(_OverlayModel);

var _mobxStateTree = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var APIFactory = __webpack_require__(5);

var DropZonesOverlayState = function () {
	function DropZonesOverlayState(options) {
		_classCallCheck(this, DropZonesOverlayState);

		this._content = options.content;
		this._features = options.features;
		this._state = this._features['state'];
		this._visualization = this._features['Visualization'];
		this._dashboard = this._features['Dashboard.API'];
		this._dashboardState = this._features['Dashboard.DashboardState'];
		this._previousAuthoringState = this._dashboardState.getUiState().authoring;
	}

	_createClass(DropZonesOverlayState, [{
		key: 'getAPI',
		value: function getAPI() {
			return this._api;
		}
	}, {
		key: 'initialize',
		value: function initialize() {
			this._api = APIFactory.createAPI(this, [_DropZonesOverlayStateAPI2.default]);
			this._overlayModel = _OverlayModel2.default.create({
				slotsModel: {}
			}, {
				dashboardApi: this._dashboard,
				content: this._content
			});
			this._onUiStateChangeCallback = this._onUiStateChange.bind(this);
			this._dashboardState.onUiStateChange(this._onUiStateChangeCallback);
			this._dashboard.on('tab:tabChanged', this._tabChange, this);
		}
	}, {
		key: 'getModel',
		value: function getModel() {
			return this._overlayModel;
		}
	}, {
		key: 'show',
		value: function show() {
			this._overlayModel.setOverlayState(true /*display*/);
		}
	}, {
		key: 'hide',
		value: function hide() {
			this._overlayModel.setOverlayState(false /*display*/);
		}
	}, {
		key: 'destroy',
		value: function destroy() {
			this._dashboardState.offUiStateChange(this._onUiStateChangeCallback);
			this._dashboard.off('tab:tabChanged', this._tabChange, this);
			(0, _mobxStateTree.destroy)(this._overlayModel);
			this._dashboard = null;
			this._api = null;
			this._overlayModel = null;
		}
	}, {
		key: '_whenVisualizationReady',
		value: function _whenVisualizationReady() {
			return this._state.whenStatusChanges(this._state.STATUS.RENDERED);
		}
	}, {
		key: '_onUiStateChange',
		value: function _onUiStateChange(uiState) {
			var _this = this;

			this._whenVisualizationReady().then(function () {
				if (_this._api && _this._previousAuthoringState !== uiState.authoring) {
					var shouldShow = uiState.authoring && !uiState.eventGroups;
					if (shouldShow && !_this._isVisualizationMappingComplete()) {
						_this.show && _this.show();
					} else {
						_this.hide && _this.hide();
					}
					_this._previousAuthoringState = uiState.authoring;
				}
			});
		}
	}, {
		key: '_tabChange',
		value: function _tabChange() /*payload*/{
			var _this2 = this;

			return this._whenVisualizationReady().then(function () {
				if (_this2._api && _this2._previousAuthoringState && !_this2._isVisualizationMappingComplete()) {
					_this2.show && _this2.show();
				} else {
					_this2.hide && _this2.hide();
				}
			});
		}
	}, {
		key: '_isVisualizationMappingComplete',
		value: function _isVisualizationMappingComplete() {
			if (this._visualization) {
				return this._visualization.getSlots().isMappingComplete();
			}
		}
	}]);

	return DropZonesOverlayState;
}();

module.exports = DropZonesOverlayState;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
var DropZonesOverlayStateAPI = function () {
	function DropZonesOverlayStateAPI() {
		_classCallCheck(this, DropZonesOverlayStateAPI);
	}

	_createClass(DropZonesOverlayStateAPI, [{
		key: "getModel",

		/**
   * @function DropZonesOverlayStateAPI#getModel
   * @description get the instance of OverlayModel
   * @return {OverlayModel} the instance of OverlayModel
   */
		value: function getModel() {}

		/**
   * @function DropZonesOverlayStateAPI#show
   * @description show the overlay drop zones after it is being mounted
   */

	}, {
		key: "show",
		value: function show() {}

		/**
   * @function DropZonesOverlayStateAPI#show
   * @description hide the overlay drop zones after it is being mounted
   */

	}, {
		key: "hide",
		value: function hide() {}
	}]);

	return DropZonesOverlayStateAPI;
}();

exports.default = DropZonesOverlayStateAPI;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _mobxStateTree = __webpack_require__(1);

var _SlotsModel = __webpack_require__(29);

var _SlotsModel2 = _interopRequireDefault(_SlotsModel);

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
var OVERLAY_STATE = {
	DISPLAY: 'DISPLAY',
	HIDE: 'HIDE',
	SMALL: 'SMALL'
};

var SUPPORT_SMALL_VIEW_CHARTS = ['Scatter', 'PackedBubble', 'HierarchicalPackedBubble', 'Wordle', 'Treemap', 'Dial', 'Bubble', 'Heatmap'];
var SUPPORT_SMALL_VIEW_CHARTS_WIDE = ['DualAxis'];
var MINIMUM_SIZE = 250;
var SMALL_VIEW_SIZE = 300;
var SMALL_VIEW_WIDE_SIZE = 400;

exports.default = _mobxStateTree.types.model('OverlayModel', {
	slotsModel: _SlotsModel2.default,
	modelVer: _mobxStateTree.types.optional(_mobxStateTree.types.number, 0)
}).volatile(function () {
	return {
		content: null,
		dashboardApi: null,
		overlayState: ''
	};
}).views(function (self) {
	return {
		/**
   * @return {array} slot apis
   */
		getSlotInfo: function getSlotInfo() {
			if (self.slotsModel && (0, _mobxStateTree.isAlive)(self.slotsModel)) {
				return self.slotsModel.getSlotInfo();
			} else {
				return [];
			}
		},

		/**
   * @param {Object} slot - slot api
   * @return {Object} - SlotDataItemHandler
   */
		getSlotDataItemHandler: function getSlotDataItemHandler(slot, indexInSlot) {
			if (self.slotsModel) {
				return self.slotsModel.getSlotDataItemHandler(slot, indexInSlot);
			}
		},


		get OVERLAY_STATE() {
			return OVERLAY_STATE;
		}
	};
}).actions(function (self) {
	var listeners = [];

	/**
  * @param {String} layerId
  * @returns true/false to hide/show layers
  */
	var _isHideLayer = function _isHideLayer(visualization, layerId) {
		var visDefinition = visualization.getDefinition();
		var datasets = visDefinition.getDatasetList() || [];
		var layer = datasets.find(function (dataset) {
			return dataset.id === layerId;
		}) || {};
		return !layer.caption;
	};

	/**
 * returns an array of objects that describe slots, the views and layers they're associated with,
 * TODO: In future, this function can be extended to include items that are 'context' (dataItems in a view not mapped to a slot)
 * @param visualization visualization api
 * @returns an array of Slot/View information objects by view (or layer depending on how you think of it!)
 */
	var _getSlotInfoForEachView = function _getSlotInfoForEachView(visualization) {
		var slots = visualization.getSlots().getSlotList();
		var slotDefinitions = visualization.getDefinition().getSlotList();
		var sharedSlots = slotDefinitions.filter(function (slotDefn) {
			return slotDefn.getDatasetIdList().length > 1;
		});
		var slotAndViewInfoArray = [];
		if (sharedSlots.length > 0) {
			// single UI layer
			var defnLayerId = 'data';
			slotAndViewInfoArray.push({
				slotAPIs: slots || [],
				layerId: defnLayerId,
				layerCaption: null,
				isHideLayer: _isHideLayer(visualization, defnLayerId)
			});
		} else {
			var slotsGroupedByLayer = _underscore2.default.groupBy(slots, function (slot) {
				return slot.getDefinition().getDatasetIdList()[0];
			});
			//Ensure an array of slots arrays is returned in definition order.
			visualization.getDefinition().getDatasetList().forEach(function (dataset, index) {
				var slotsByDataset = slotsGroupedByLayer[dataset.id];
				slotAndViewInfoArray.push({
					slotAPIs: slotsByDataset || [],
					layerId: dataset.id,
					layerCaption: dataset.caption || dataset.id,
					isHideLayer: _isHideLayer(visualization, dataset.id),
					open: index === 0
				});
			});
		}
		return slotAndViewInfoArray;
	};

	var _debouncedUpdateModel = null;
	var _onSetup = null;
	var _onModelChange = null;

	return {
		afterCreate: function afterCreate() {
			// @todo: STOP using debounce
			// SHOULD use transaction feature instead
			// Event handling of selection and event handling for mapping change needs to be seprated.
			// Combining the two, results in unnecessary on/off upon mapping.
			// Added [setupEvents] to distinguish the two cases for now.
			_debouncedUpdateModel = _underscore2.default.debounce(function (setupEvents) {
				if ((0, _mobxStateTree.isAlive)(self)) {
					self._updateModel(setupEvents);
				}
			});
			// The different usage of _debouncedUpdateModel handler
			// 1. handler for content selection change.
			_onSetup = _debouncedUpdateModel.bind(this, true);
			// 2. hander for slots mapping change.
			_onModelChange = _debouncedUpdateModel.bind(this, false);

			self.content = (0, _mobxStateTree.getEnv)(self).content;
			self.dashboardApi = (0, _mobxStateTree.getEnv)(self).dashboardApi;
			if (self.slotsModel) {
				self.slotsModel.setDashboardApi(self.dashboardApi);
			}
			_onSetup();
		},
		beforeDestroy: function beforeDestroy() {
			listeners.forEach(function (listener) {
				return listener.remove();
			});
		},

		/**
   * Set state of overlay
   * if display is falsy, the overlay will hidden
   * if display is truthy, the model computes if the container has enough space for a full, small or hidden view
   * @param {boolean} display 
   */
		setOverlayState: function setOverlayState(display) {
			if (display) {
				self.overlayState = self._getSizeState();
			} else {
				self.overlayState = OVERLAY_STATE.HIDE;
			}
		},

		/** decides which view state for overlay
   * a) focus mode: always show the overlay
   * b) charts that are smaller than MINIMUM_SIZE in width or height, hide the overlay
   * c) charts that support a smaller view, determine if the state is small or full based on the chart type
   */
		_getSizeState: function _getSizeState() {
			var sizeState = OVERLAY_STATE.DISPLAY;
			var contentViewDOM = self.content.getFeature('ContentViewDOM');
			var visualization = self.content.getFeature('Visualization');
			var chartType = visualization.getType();
			if (contentViewDOM) {
				var contentNode = contentViewDOM.getNode();
				var dashboardState = self.dashboardApi.getFeature('DashboardState');
				var state = self.content.getFeature('state');
				// hide overlay when in consumption mode or content has an error
				if (!dashboardState.getUiState().authoring || state && state.getError() || visualization.hasUnavailableMetadataColumns()) {
					sizeState = OVERLAY_STATE.HIDE;
				} else if (dashboardState.getUiState().focus) {
					sizeState = OVERLAY_STATE.DISPLAY;
				} else if (contentNode.offsetWidth < MINIMUM_SIZE || contentNode.offsetHeight < MINIMUM_SIZE) {
					sizeState = OVERLAY_STATE.HIDE;
				} else if (SUPPORT_SMALL_VIEW_CHARTS.includes(chartType)) {
					sizeState = contentNode.offsetWidth < SMALL_VIEW_SIZE ? OVERLAY_STATE.SMALL : OVERLAY_STATE.DISPLAY;
				} else if (SUPPORT_SMALL_VIEW_CHARTS_WIDE.includes(chartType)) {
					sizeState = contentNode.offsetWidth < SMALL_VIEW_WIDE_SIZE ? OVERLAY_STATE.SMALL : OVERLAY_STATE.DISPLAY;
				}
			}
			return sizeState;
		},
		_updateModel: function _updateModel(setupEvents) {
			self._setOverlayState();
			self._setSlots(setupEvents);
		},
		_setOverlayState: function _setOverlayState() {
			var visualization = self.content.getFeature('Visualization');
			if (visualization) {
				try {
					var isMappingComplete = visualization.getSlots().isMappingComplete();
					self.overlayState = isMappingComplete ? OVERLAY_STATE.HIDE : self._getSizeState();
				} catch (e) {
					self.overlayState = OVERLAY_STATE.HIDE;
				}
			} else {
				self.overlayState = OVERLAY_STATE.HIDE;
			}
		},
		_setSlots: function _setSlots(setupEvents) {
			var slotInfo = [];
			if (self.overlayState === OVERLAY_STATE.DISPLAY) {
				var visualization = self.content.getFeature('Visualization');
				if (visualization) {
					slotInfo = _getSlotInfoForEachView(visualization) || [];
				}
			}
			if (self.slotsModel && (0, _mobxStateTree.isAlive)(self.slotsModel)) {
				if (setupEvents) {
					self.slotsModel.clear();
					self.slotsModel.setContent(self.content);
					self.slotsModel.setVisualization();
					self.slotsModel.setUpEvents(_onModelChange);
				}
				self.slotsModel.setSlotInfo(slotInfo);
				self.modelVer++;
			}
		}
	};
});

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _mobxStateTree = __webpack_require__(1);

var _VisSlotDataItemHandler = __webpack_require__(30);

var _VisSlotDataItemHandler2 = _interopRequireDefault(_VisSlotDataItemHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
var MemUtil = __webpack_require__(34);

exports.default = _mobxStateTree.types.model('SlotsModel', {
	slotInfo: _mobxStateTree.types.optional(_mobxStateTree.types.array(_mobxStateTree.types.frozen()), [])
}).volatile(function (self) {
	return {
		visSlotDataItemHandlersMap: {},
		content: null,
		visualization: null,
		dashboardAPI: null,
		/**
   * @param {Object} slot - slot api
   * @return {Object} - SlotDataItemHandler
   */
		getSlotDataItemHandler: function getSlotDataItemHandler(slot, indexInSlot) {
			if (!self.content) {
				return null;
			}
			if (!self.visualization) {
				self.setVisualization();
			}
			var handlerKey = [slot.getDefinition().getDatasetIdList()[0], slot.getDefinition().getId(), indexInSlot].join(':');

			//Re-use or allocate a slotDataItemHandler.
			var slotDataItemHandler = self.visSlotDataItemHandlersMap[handlerKey];
			if (!slotDataItemHandler || MemUtil.isDestroyed(slotDataItemHandler.slot)) {
				var fnAcceptsOlapV2 = void 0;
				if (self.visualization.getType() === 'Crosstab') {
					var utils = self.content.getFeature('VisDnD.utils');
					if (utils) {
						fnAcceptsOlapV2 = utils.acceptsOlapV2;
					}
				}
				var slotActions = self.content.getFeature('SlotActions');
				var cbGetActionsForSlot = slotActions.getSlotActionList.bind(slotActions);
				slotDataItemHandler = new _VisSlotDataItemHandler2.default(slot, indexInSlot, cbGetActionsForSlot, self.visualization, self.dashboardApi, self.content, fnAcceptsOlapV2);
				self.setVisSlotDataItemHandler(handlerKey, slotDataItemHandler);
			}
			return slotDataItemHandler;
		}
	};
}).views(function (self) {
	return {
		/**
   * @return {array} slot info
   */
		getSlotInfo: function getSlotInfo() {
			return self.slotInfo;
		}
	};
}).actions(function (self) {
	var eventCallback = null;
	return {
		beforeDestroy: function beforeDestroy() {
			self.clearEvents();
		},
		setContent: function setContent(content) {
			self.content = content;
		},
		setUpEvents: function setUpEvents(callback) {
			if (self.content) {
				eventCallback = callback;
				self.content.on('change', eventCallback);
				self.visDefinitions = self.dashboardApi.getFeature('VisDefinitions');
				self.visDefinitions.on('refresh:definition', eventCallback);
			}
		},
		setVisualization: function setVisualization() {
			if (self.content) {
				self.visualization = self.content.getFeature('Visualization');
			} else {
				self.visualization = null;
			}
		},
		setDashboardApi: function setDashboardApi(dashboardApi) {
			self.dashboardApi = dashboardApi;
		},
		setVisSlotDataItemHandler: function setVisSlotDataItemHandler(handlerKey, slotDataItemHandler) {
			self.visSlotDataItemHandlersMap[handlerKey] = slotDataItemHandler;
		},
		setSlotInfo: function setSlotInfo() {
			var slotInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

			self.slotInfo = slotInfo;
		},
		clear: function clear() {
			self.clearEvents();
			self.content = null;
			self.visualization = null;
			self.slotInfo = [];
			self.visSlotDataItemHandlersMap = {};
		},
		clearEvents: function clearEvents() {
			if (self.content) {
				self.content.off('change', eventCallback);
				self.visDefinitions.off('refresh:definition', eventCallback);
				eventCallback = null;
			}
		}
	};
});

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = exports.MULTI_MEASURES_SERIES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ToolbarHelper = __webpack_require__(31);

var _ToolbarHelper2 = _interopRequireDefault(_ToolbarHelper);

var _utils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2019, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
// -----TEMPORARY------- will remove after we have the feature apis of these things
var ActionTypes = __webpack_require__(33);
var MULTI_MEASURES_SERIES = exports.MULTI_MEASURES_SERIES = '_multiMeasuresSeries';
// ---------------------

/**
 * The VisSlotDataItemHandler is a helper class which handles assigning and moving DataItems in slots
 * Items can be inserted/replaced into slots from metadata (as provided by the metadata tree)
 * or come from other SlotDataItemHandler instances (when other slot items being moved or swapped).
 * The main purpose of this helper class is to support drag and drop in the slot editor.
 */
var VisSlotDataItemHandler = function () {
	/**
   * @param slotAPI - the slotAPI to bind this action handler to
   * @param indexInSlot - the index of the data item of interest in this slotType
   * @param cbGetActionsForSlot - a callback function that can provide the actions associated with this slot/dataItemModel
   * @param visualization - the new visualization API
   * @param dashboardApi - dashboardApi
   * @param content - contentAPI associated with the slots
   * @param fnAccepts - injected function to validate accepts, it is called if it is defined, currently used for V2 xtab
   */
	function VisSlotDataItemHandler(slotAPI, indexInSlot, cbGetActionsForSlot, visualization, dashboardApi, content, fnAccepts) {
		_classCallCheck(this, VisSlotDataItemHandler);

		this.content = content;
		this.dashboardApi = dashboardApi;
		this.transactionApi = dashboardApi.getFeature('Transaction');
		this.indexInSlot = indexInSlot;
		this._getActions = cbGetActionsForSlot;
		this.setSlotAPI(slotAPI);
		this._toolbarHelper = new _ToolbarHelper2.default();
		this.visualization = visualization;
		this.visDnD = this.content.getFeature('VisDnD');
		this.fnAccepts = fnAccepts;
	}

	_createClass(VisSlotDataItemHandler, [{
		key: 'setSlotAPI',
		value: function setSlotAPI(slot) {
			this.slot = slot;
			this.slotId = slot.getDefinition().getId();
		}
	}, {
		key: 'getSlotAPI',
		value: function getSlotAPI() {
			return this.slot;
		}
	}, {
		key: 'getContentId',
		value: function getContentId() {
			return this.content.getId();
		}
	}, {
		key: 'getGraphicData',
		value: function getGraphicData() {
			// if this content supports the property `value.graphic.content`,
			// then we return the value of it, otherwise return null
			if (this.content.getPropertyNameList().indexOf('value.graphic.content') !== -1) {
				return this.content.getPropertyValue('value.graphic.content');
			}
			return null;
		}
	}, {
		key: 'getDatasourceId',
		value: function getDatasourceId() {
			var dataSource = this.visualization.getDataSource();
			if (dataSource) {
				return dataSource.getId();
			}
			return null;
		}
	}, {
		key: 'getFilterStringAndNumber',
		value: function getFilterStringAndNumber() {
			var result = {};
			var dataItem = this.slot.getDataItemList()[this.indexInSlot];
			var columnId = dataItem && dataItem.getColumnId();
			if (columnId && columnId !== MULTI_MEASURES_SERIES) {
				// Find the local filter which can be displayed under the dataItem.
				var localFilters = this.visualization.getLocalFilters();
				var localFiltersInfo = localFilters && localFilters.getFilterList();
				if (localFiltersInfo && localFiltersInfo.length) {
					var columnFilter = localFiltersInfo.find(function (localFilterInfo) {
						if (localFilterInfo.readOnly) {
							return false;
						}
						if (localFilterInfo.filterBins) {
							if (dataItem.getBinning()) {
								return localFilterInfo.id === dataItem.getId();
							}
						} else {
							if (localFilterInfo.aggregationType) {
								return localFilterInfo.columnId === columnId && dataItem.getAggregation() === localFilterInfo.aggregationType;
							} else {
								// If the case is when there is an ordinal and attribute we dont want to
								// display the filter beneath it.
								return localFilterInfo.columnId === columnId;
							}
						}

						return false;
					});
					if (columnFilter) {
						// get filterString
						var filtersDesc = localFilters.getFiltersDesc();
						var columnFilterDesc = filtersDesc.find(function (filterDesc) {
							return filterDesc.dataId === columnFilter.id;
						});
						if (columnFilterDesc) {
							result.filterString = columnFilterDesc.description;
						}
						// get number of filter items
						result.numberOfFilterItems = (0, _utils.getNumberOfFilterItems)(columnFilter);
					}
				}
			}
			return result;
		}
	}, {
		key: 'isMeasureGroupItem',
		value: function isMeasureGroupItem() {
			if (this._isMultiMeasuresSeriesSlot()) {
				var thisDataItem = this.slot.getDataItemList()[this.indexInSlot];
				return thisDataItem && thisDataItem.getColumnId() === '_multiMeasuresSeries';
			}
			return false;
		}

		// This function is copied from the static function SlotAPIUtil.isMultiMeasuresSeriesSlot in live-widget component

	}, {
		key: '_isMultiMeasuresSeriesSlot',
		value: function _isMultiMeasuresSeriesSlot() {
			var dataItemList = this.slot.getDataItemList();
			return dataItemList.find(function (dataItem) {
				return dataItem.getColumnId() === MULTI_MEASURES_SERIES;
			}) ? true : false;
		}
	}, {
		key: '_getTargetIndex',
		value: function _getTargetIndex(dropAfter) {
			return this.indexInSlot + (dropAfter ? 1 : 0);
		}
	}, {
		key: 'insertItemFromTypeInSlot',
		value: function insertItemFromTypeInSlot(metadataColumn, sourceId, options) {
			var replaceSlotItem = options.replaceSlotItem;

			var dataSource = this.dashboardApi.getFeature('DataSources').getDataSource(sourceId);
			if (dataSource) {
				var target = this.getDropTargetInfo( /*addAfter*/!replaceSlotItem);
				var source = {
					type: 'metadataColumns',
					data: [metadataColumn]
				};
				if (metadataColumn && metadataColumn.getType()) {
					//NOTE: onDrop will validate (call accepts)
					this.visDnD.onDrop(source, target);
				}
			}
		}

		/* check if this slot can have one more item in it*/

	}, {
		key: 'canAcceptMoreItems',
		value: function canAcceptMoreItems() {
			return this._acceptsCommon(1, true);
		}

		/**
   * @returns {number} of slot items in a slot
   */

	}, {
		key: 'getNumberItemsInSlot',
		value: function getNumberItemsInSlot() {
			return this.slot.getDataItemList().length;
		}
	}, {
		key: 'getDropTargetInfo',
		value: function getDropTargetInfo(addAfter) {
			var additionalInfoOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

			var dropTargetInfo = {
				type: 'slot.item',
				info: {
					contentId: this.getContentId(),
					slot: this.getSlotAPI(),
					indexInSlot: this.indexInSlot,
					addAfter: addAfter
				}
			};

			Object.keys(additionalInfoOptions).forEach(function (key) {
				dropTargetInfo.info[key] = additionalInfoOptions[key];
			});
			return dropTargetInfo;
		}
	}, {
		key: '_acceptsCommon',
		value: function _acceptsCommon(countOfItemsToDrop, addAfter) {
			//IF this definition contains (or could contain) a multiMeasuresSeries item,
			//You CAN drop on or after in a values slot (even though values has maxItems of 1 => multi-items go where 'Measure Group (n)' is)
			if (this.slotId === 'values' && this._isMultiMeasuresSeriesSlot() || this.slot.getDefinition().isMultiMeasureSupported()) {
				return true;
			}

			//You CAN'T drop more items than the slot can allow.
			return !this._exceedsItemsLimit(countOfItemsToDrop, addAfter);
		}
	}, {
		key: '_exceedsItemsLimit',
		value: function _exceedsItemsLimit(countOfItemsToDrop, addAfter) {
			var limit = this.slot.getDefinition().getMaxItems();
			if (typeof limit !== 'number' || limit < 0) {
				// no limit verification if maxItems is null or undefined or something else than a positive number (0 is considered as positive in this function)
				return false;
			}
			var mappedItems = this.slot.getDataItemList().length;
			//When dropping on top of an existing slot dataItem, we replace it with the items we're dropping.
			var mappedItemsAfterDrop = countOfItemsToDrop + mappedItems - (addAfter ? 0 : 1);
			return mappedItemsAfterDrop > limit;
		}

		/**
   * Performs swaps of the item represented by the sourceDataItemHandler with the item represented by this handler
   * either as a 'replace' or an 'addAfter' operation.
   * NOTE: This function is now only used for the Slot to Slot A11Y case.
   * @param sourceDataItemHandler - The handler representing the source DataItem being moved.
   * @param addAfter (optional) - a boolean indicating if this is a replace or append wrt this dataItem/index.
   */

	}, {
		key: 'swapSlotItems',
		value: function swapSlotItems(sourceDataItemHandler, addAfter) {
			return this.onDrop(
			//SourceInfo (as defined in DnDSlotItemHandler)
			{
				data: {
					source: {
						slot: sourceDataItemHandler.getSlotAPI(),
						indexInSlot: sourceDataItemHandler.indexInSlot
					}
				}
			},
			//TargetInfo (as defined in DnDSlotItemHandler)
			this.getDropTargetInfo(addAfter));
		}

		/**
   * @returns A11YData in the form that the provider needs to call insert.
   */

	}, {
		key: 'onDropA11Y',
		value: function onDropA11Y(addAfter) {
			var target = this.getDropTargetInfo(addAfter);
			this.visDnD.onDrop({ type: 'A11YMetadataColumns' }, target);
		}

		//A generic handler where data is expected to be in the form built for drag and drop.

	}, {
		key: 'onDrop',
		value: function onDrop(source, target) {
			//The only one we support locally for onDrop is slot sources.
			if (source.data.source) {
				// If we are swapping onto same item, we are done
				if (source.data.source.slot === this.getSlotAPI() && source.data.source.indexInSlot == this.indexInSlot) {
					return;
				}
				var sourceSlot = source.data.source.slot;
				var sourceIndex = source.data.source.indexInSlot;
				var addAfter = target.info.addAfter;
				var transactionToken = this.transactionApi.startTransaction();
				var sourceDataItem = sourceSlot.getDataItemList()[sourceIndex];
				var thisDataItem = this.slot.getDataItemList()[this.indexInSlot];
				var thisDataItemUniqueId = thisDataItem && thisDataItem.getId();

				if (sourceSlot.getId() === this.slotId) {
					// Handle swapping items within the same slot
					this._swapItemsInTheSameSlot(sourceDataItem.getId(), thisDataItemUniqueId, addAfter, transactionToken);
				} else if (addAfter || !thisDataItem) {
					this._moveItemToSlot(sourceSlot, sourceDataItem, addAfter, transactionToken);
				} else {
					this._swapItemsBetweenSlots(sourceSlot, sourceDataItem.getId(), thisDataItemUniqueId, transactionToken);
				}
				this.transactionApi.endTransaction(transactionToken);
			}
		}
	}, {
		key: '_swapItemsInTheSameSlot',
		value: function _swapItemsInTheSameSlot(sourceItemUniqueId, targetItemUniqueId, addAfter, transactionToken) {
			var dataItemRefs = this.slot.getDataItemList().map(function (dataItem) {
				return dataItem.getId();
			});

			var sourceIndex = dataItemRefs.indexOf(sourceItemUniqueId);
			var targetIndex = dataItemRefs.indexOf(targetItemUniqueId);

			if (addAfter || targetIndex === -1) {
				dataItemRefs.splice(targetIndex + 1, 0, sourceItemUniqueId);
				sourceIndex = sourceIndex > targetIndex ? sourceIndex + 1 : sourceIndex;
				dataItemRefs.splice(sourceIndex, 1);
			} else {
				dataItemRefs[sourceIndex] = targetItemUniqueId;
				dataItemRefs[targetIndex] = sourceItemUniqueId;
			}
			this.visualization.getSlots().setDataItems(dataItemRefs, this.slotId, transactionToken);
		}

		//A user moves an item to a new slot to 'add it after' something.
		//(either the another item or the slot heading).

	}, {
		key: '_moveItemToSlot',
		value: function _moveItemToSlot(sourceSlot, sourceDataItem, addAfter, transactionToken) {
			var sourceDataItemId = sourceDataItem.getId();
			var targetDataItemRefs = this.slot.getDataItemList().map(function (dataItem) {
				return dataItem.getId();
			});
			var targetIndex = this._getTargetIndex(addAfter);
			// Add this data item to the new slot
			targetDataItemRefs.splice(targetIndex, 0, sourceDataItemId);
			this.visualization.getSlots().setDataItems(targetDataItemRefs, this.slotId, transactionToken);
		}

		//This is the case where a user takes a slot and drops it on top of another slot (the two should swap)

	}, {
		key: '_swapItemsBetweenSlots',
		value: function _swapItemsBetweenSlots(sourceSlot, sourceDataItemUniqueId, targetDataItemUniqueId, transactionToken) {
			// Update target slot
			var targetSlotId = this.slotId;
			var targetDataItemRefs = this.slot.getDataItemList().map(function (dataItem) {
				return dataItem.getId();
			});
			var targetIndex = targetDataItemRefs.indexOf(targetDataItemUniqueId);
			targetDataItemRefs[targetIndex] = sourceDataItemUniqueId;

			// Update source slot
			var sourceSlotId = sourceSlot.getDefinition().getId();
			var sourceDataItemRefs = sourceSlot.getDataItemList().map(function (dataItem) {
				return dataItem.getId();
			});
			var sourceIndex = sourceDataItemRefs.indexOf(sourceDataItemUniqueId);
			sourceDataItemRefs[sourceIndex] = targetDataItemUniqueId;

			// swap
			this.visualization.getSlots().setDataItems(targetDataItemRefs, targetSlotId, transactionToken);
			this.visualization.getSlots().setDataItems(sourceDataItemRefs, sourceSlotId, transactionToken);
		}

		/**
   * @returns the actions associated with this dataItem and slotType
   */

	}, {
		key: 'getActions',
		value: function getActions() {
			var slots = this.slot.getDataItemList();
			var singleSlot = this._getSingleSlot(slots, this.indexInSlot);
			var slotActions = this.visualization.getSlots().getSlot(this.slotId).getDefinition().getProperty('actions');
			var actionExt = singleSlot ? slotActions : null;
			var options = {};
			if (actionExt && actionExt.length > 0) {
				options.actionsToKeep = actionExt;
			}
			return Promise.resolve(this._getActions(this.slotId, this.indexInSlot, options).map(function (action) {
				return _extends({
					text: action.label
				}, action);
			}));
		}

		/**
   * Brings up the UI to execute the slot action menu.
   * @param parentNode - the node to set the menu under.
   * @param editorOptions - an object to control things like placement of the menu.
   */

	}, {
		key: 'openSlotActionMenu',
		value: function openSlotActionMenu(parentNode, editorOptions) {
			var _this = this;

			return this.getActions().then(function (actions) {
				var actionList = actions.map(function (action) {
					return _extends({
						order: action.order || ActionTypes[action.name]
					}, action);
				}).sort(function (a, b) {
					return a.order - b.order;
				});
				_this._toolbarHelper.buildActionToolbar(actionList, parentNode, /*label*/null, editorOptions);
				return actionList;
			});
		}

		/* check if action menu is open */

	}, {
		key: 'isSlotActionMenuOpened',
		value: function isSlotActionMenuOpened() {
			return this._toolbarHelper.getToolbar() ? true : false;
		}
	}, {
		key: '_getSingleSlot',
		value: function _getSingleSlot(slots, mapIndex) {
			//if slots length is not 1, return null
			//if mapIndex exists and its an array of length > 1, return null
			var isArrayOfMapIndex = mapIndex && mapIndex instanceof Array && mapIndex.length > 1;
			if (slots.length !== 1 || isArrayOfMapIndex) {
				return null;
			}
			return slots[0];
		}
		/**
   * Set the index in the slot for a data item
   * @param {int} indexInSlot
   */

	}, {
		key: 'setIndexInSlot',
		value: function setIndexInSlot(indexInSlot) {
			this.indexInSlot = indexInSlot;
		}
	}, {
		key: 'getPickTreeContext',
		value: function getPickTreeContext(includeMetadata) {
			var context = {
				type: this.slot.getDefinition().getType()
			};
			if (includeMetadata && this.indexInSlot > -1) {
				context.metadataColumn = this.slot.getDataItemList()[this.indexInSlot].getMetadataColumn();
			}
			return context;
		}
	}]);

	return VisSlotDataItemHandler;
}();

exports.default = VisSlotDataItemHandler;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| IBM Cognos Products: Dashboard
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Toolbar = __webpack_require__(32);

var ToolbarHelper = function () {
	/**
  * The ToolbarHelper is is designed to hide common jquery authoring toolbar code
  * for things like the filter dialog or the slot action menu.
  */
	function ToolbarHelper() {
		_classCallCheck(this, ToolbarHelper);
	}

	_createClass(ToolbarHelper, [{
		key: 'getToolbar',
		value: function getToolbar() {
			return this._actionMenuToolbar;
		}

		/**
   * build an action toolbar based on dashboard authoring toolbar class.
   * @param aActions - the actions to be added to the toolbarRoot
   * @param parentNode - the parentNode that contains the toolbar.
   * @param label - a label for the toolbar
   * @param userOptions - options such as placement and the attachPoint (class of the node where the toolbar will live)
   */

	}, {
		key: 'buildActionToolbar',
		value: function buildActionToolbar(aActions, parentNode, sLabel, userOptions) {
			var toolbarOptions = _underscore2.default.clone(userOptions);
			toolbarOptions.textOnly = true;
			toolbarOptions.flyoutClass = 'popover actionToolbarPopover text';

			this.$parentNode = (0, _jquery2.default)(parentNode);
			this.$parentNode.addClass('action-menu-opened');

			//We expect to find a div with this class under the parent to root the menu at (by default, the className is menuroot )
			var $attachPoint = this.$parentNode.find(userOptions.attachPoint || '.toolbarRoot');

			var toolbar = new Toolbar(toolbarOptions);
			toolbar.setName(sLabel);
			toolbar.addItems(aActions);
			toolbar.setSelectionContext([$attachPoint]);
			toolbar.show(toolbarOptions.placement);

			// This event is triggered only when user clicks away or press Escape to hide the toolbar.
			// We refresh the UI after that.
			// Other events like onPopupClose and bspopover.hidden are called when toolbar is changed.
			toolbar.on('flyout:hide', this.removeToolbar, this);
			toolbar.on('toolbar:remove', this.onToolbarRemove.bind(this));

			this._actionMenuToolbar = toolbar;
		}
	}, {
		key: 'removeToolbar',
		value: function removeToolbar() {
			if (this._actionMenuToolbar) {
				//Passing true to request the 'toolbar:remove' to trigger
				this._actionMenuToolbar.remove(true /* triggerEvent */);
			}
		}

		//Default implementation when the toolbar is removed.
		//A user can override this to perform some specific action at remove time in the arguments.

	}, {
		key: 'onToolbarRemove',
		value: function onToolbarRemove() {
			if (this.$parentNode) {
				this.$parentNode.removeClass('action-menu-opened');
				this.$parentNode = null;
			}
			if (this._actionMenuToolbar) {
				this._actionMenuToolbar = null;
			}
		}
	}]);

	return ToolbarHelper;
}();

exports.default = ToolbarHelper;

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_32__;

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_33__;

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_34__;

/***/ })
/******/ ])});;


// WEBPACK FOOTER //
// DropZonesOverlayState.js